import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectProps} from "@/components/select/Select.types.ts";
import {AccountUser} from "@/lib/types/accounts.ts";

const UserOption = ({data, ...props}: OptionProps<AccountUser>) => {
  return (
    <components.Option {...props} data={data}>
      <span className="d-flex flex-column">
        <span className="pulseTextBodyBold">
          {data.first_name} {data.last_name}
        </span>
        <span className="me-auto pulseTextBodySmall">{data.email}</span>
      </span>
    </components.Option>
  );
};

export const UserSelect = forwardRef(
  ({options, ...props}: SelectProps<AccountUser, boolean>, ref: ForwardedRef<SelectInstance<AccountUser, boolean>>) => {
    return (
      <Select<AccountUser, boolean>
        ref={ref}
        components={{Option: UserOption}}
        getOptionLabel={(user: AccountUser) => `${user.first_name} ${user.last_name}`}
        getOptionValue={(user: AccountUser) => user.id.toString()}
        options={options}
        {...props}
      />
    );
  }
);
